import styled, { css } from 'styled-components';
import { pxToRem } from '../../../design-tokens/style-utilities';
export const containerWrapperStyles = ({ theme, $withConstrainedWidth, $variant, }) => css `
	width: 100%;

	@media (min-width: ${pxToRem(theme.containerWidth.containerWidthMax)}) {
		${$withConstrainedWidth &&
    css `
			display: flex;
			justify-content: center;
		`}
	}

	${$variant === 'featured' &&
    css `
		background-color: ${theme.colors.extralight.bgSite};
	`}
`;
export const ContainerWrapper = styled.div `
	${containerWrapperStyles}
`;
export const containerContentStyles = ({ theme, $withConstrainedWidth, $withOuterSpacing, }) => css `
	flex: 1;

	${$withConstrainedWidth &&
    css `
		max-width: ${pxToRem(theme.containerWidth.containerWidthMax)};
	`}

	${$withOuterSpacing === true &&
    css `
		margin: ${pxToRem(theme.spacing['600'])} ${pxToRem(theme.spacing['300'])};

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.xs)}) {
			margin: ${pxToRem(theme.spacing['600'])} ${pxToRem(theme.spacing['400'])};
		}

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			margin: ${pxToRem(theme.spacing['600'])} ${pxToRem(theme.spacing['500'])};
		}
	`}

	${$withOuterSpacing === 'horizontal' &&
    css `
		margin: 0 ${pxToRem(theme.spacing['300'])};

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.xs)}) {
			margin: 0 ${pxToRem(theme.spacing['400'])};
		}

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			margin: 0 ${pxToRem(theme.spacing['500'])};
		}
	`}

	${$withOuterSpacing === 'vertical' &&
    css `
		margin: ${pxToRem(theme.spacing['600'])} 0;
	`}

	${['top', 'right', 'bottom', 'left'].map((direction) => $withOuterSpacing[direction] &&
    css `
				margin-${direction}: ${pxToRem(theme.spacing[direction === 'right' || direction === 'left' ? '300' : '600'])};	

				@media (min-width: ${pxToRem(theme.viewportBreakpoint.xs)}) {
					margin-${direction}: ${pxToRem(theme.spacing[direction === 'right' || direction === 'left' ? '400' : '600'])};
				}

				@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
					margin-${direction}: ${pxToRem(theme.spacing[direction === 'right' || direction === 'left' ? '500' : '600'])};
				}
			`)}
`;
export const ContainerContent = styled.div `
	${containerContentStyles}
`;
